<template>
  <div class="loader" :class="{ isLoading }">
    <div class="loader__Inner">
      <div class="loader__Spinner">
        <Icon name="spinner" />
      </div>

      <p class="loader__Text">{{ $t('loader.firstMessage') }}</p>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    active: {
      type: Boolean,
      default: false
    },
  });

  const isLoading = computed(() => props.active);

  function toggleSpinner(value) {
    document.documentElement.classList[value ? 'add' : 'remove']('isOverflow');
    document.documentElement.classList[value ? 'add' : 'remove']('isCustomLoader');
  }

  onMounted(() => {
    toggleSpinner(isLoading.value);
  });

  watch(() => isLoading.value, (value) => {
    toggleSpinner(value);
  });
</script>